import { createAction } from '@reduxjs/toolkit'

import axiosInstance from 'utils/axios'
import { TData, TFilters, TSort, TViewMode } from 'pages/AiCalls/helpers/constant'

export const setPage = createAction<number>('aiCalls/setPage')
export const setPageSize = createAction<number>('aiCalls/setPageSize')
export const setTotal = createAction<number>('aiCalls/setTotal')
export const setData = createAction<TData>('aiCalls/setData')
export const setFilters = createAction<Partial<TFilters>>('aiCalls/setFilters')
export const setMode = createAction<TViewMode>('aiCalls/setMode')
export const setOrder = createAction<TSort>('aiCalls/setOrder')
export const resetFilters = createAction('aiCalls/resetFilters')

export async function getAiCalls(params: any) {
  const response = await axiosInstance.request({
    url: 'ai_calls',
    method: 'get',
    params,
    cache: { ignoreCache: true },
  })
  return response.data
}

export async function updateAiCall(id: number | string, data: any) {
  const payload: any = {}

  if (Object.prototype.hasOwnProperty.call(data, 'status')) {
    payload.status = data.status
  }

  if (Object.prototype.hasOwnProperty.call(data, 'note')) {
    payload.note = data.note
  }

  if (Object.prototype.hasOwnProperty.call(data, 'assignee_crm_user_id')) {
    payload.assignee_crm_user_id = data.assignee_crm_user_id
  }

  const response = await axiosInstance.request({
    url: `ai_calls/${id}`,
    method: 'patch',
    data: payload,
    cache: { ignoreCache: true },
  })
  return response.data
}

export async function getAiCallLogs(id: number | string) {
  const response = await axiosInstance.request({
    url: `ai_calls/${id}/logs`,
    method: 'get',
    cache: { ignoreCache: true },
  })
  return response.data
}

export async function getAiCallAssignees(params?: {
  keyword?: string
  crm_team_id?: string | number
}) {
  const response = await axiosInstance.request({
    url: 'ai_calls/assignees',
    method: 'get',
    params,
    cache: { ignoreCache: true },
  })
  return response.data
}
export async function getAiCallListAssignees() {
  const response = await axiosInstance.request({
    url: 'ai_calls/list_assignees',
    method: 'get',
    cache: { ignoreCache: true },
  })
  return response.data
}
